import {
    SliceFactory,
    FetchCollectionData,
    FetchItemDataType,
    ApiCollectionResponse,
} from '@europrocurement/l2d-redux-utils';
import { TypeDeDocumentTypedocumentUpdate } from '@europrocurement/l2d-domain/openApi/ApiFormalite';
import { filterDeletedCollection } from '@europrocurement/l2d-domain/utils/filterDeletedCollection';
import {
    ConfigurationParameters as OffreConfigurationParameters,
    Configuration,
    TypeDeDocumentApi,
} from '../../../openApi/ApiOffre';
import { AUTOCOMPLETE_KEY, DOCUMENT_SLICE_NAME, OFFRE_REDUCER_NAME } from '../constants';

export type DocumentApiObject = TypeDeDocumentTypedocumentUpdate & Record<string, unknown>;

export type Documents = DocumentApiObject;

const mapperDocuments = function (offers: DocumentApiObject) {
    return {
        ...offers,
    } as Documents;
};

export function createDocumentsSlice(configuration: OffreConfigurationParameters) {
    const conf = new Configuration(configuration);
    const api = new TypeDeDocumentApi(conf);

    const fetchDocumentsCollection: FetchCollectionData<DocumentApiObject> = ({
        pagination: { page, itemsPerPage },
        filters,
        xIdSociete,
        search,
        orders,
    }) => {
        let libelle: string | undefined;
        let libelleDF: string | undefined;
        let multiFieldSearch: string | undefined;
        let signable: boolean | undefined;
        let type: number | undefined;
        let statut: number | undefined;

        let orderLibelle: 'asc' | 'desc' | undefined;

        if (filters.libelle) {
            libelle = filters.libelle as string;
        }

        if (filters.libelleDF) {
            libelleDF = filters.libelleDF as string;
        }

        if (filters.signable !== undefined) {
            signable = filters.signable as boolean;
        }

        if (filters.type !== undefined) {
            type = filters.type as number;
        }

        if (filters.statut !== undefined) {
            statut = filters.statut as number;
        }

        if (search && search !== '') {
            multiFieldSearch = search;
        }

        orders.forEach((order) => {
            if (order.field === 'libelle') {
                orderLibelle = order.value;
            }
        });

        const requestParameters = {
            xIdSociete,
            page: page + 1,
            itemsPerPage,
            // Filters
            libelle,
            libelleDF,
            signable,
            type,
            statut,
            multiFieldSearch,
            // Orders
            orderLibelle,
        };

        return (
            api
                .apiTypesDocumentsGetCollection(requestParameters)
                // L'API renvoie le type de document « à plat », qui porte `deleted`.
                .then((res) => filterDeletedCollection(res.data))
                .catch((error) => {
                    console.error(error);
                }) as Promise<ApiCollectionResponse<DocumentApiObject>>
        );
    };

    const fetchDocumentsItem: FetchItemDataType<DocumentApiObject> = ({
        idItem,
        // pagination,
        xIdSociete,
    }) =>
        api
            .apiTypesDocumentsIdGet({ id: String(idItem), xIdSociete })
            .then((res) => res.data) as Promise<DocumentApiObject>;

    const { slice: documentsSlice, dataSourcesThunks: documentsDataSourcesThunks } =
        SliceFactory.createSlice<DocumentApiObject, Documents>(
            DOCUMENT_SLICE_NAME,
            OFFRE_REDUCER_NAME,
            [AUTOCOMPLETE_KEY],
            fetchDocumentsCollection,
            fetchDocumentsItem,
            mapperDocuments,
        );

    return { documentsSlice, documentsDataSourcesThunks };
}
